import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

export type LinkUnderline = 'always' | 'hover' | 'never';

export interface LinkProps {
  to?: string;
  href?: string;
  external?: boolean;
  underline?: LinkUnderline;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

const UNDERLINE: Record<LinkUnderline, string> = {
  always: 'underline',
  hover: 'no-underline hover:underline',
  never: 'no-underline',
};

const Link: React.FC<LinkProps> = ({
  to,
  href,
  external = false,
  underline = 'hover',
  children,
  className = '',
  onClick,
}) => {
  const base =
    `text-pt-forest hover:text-pt-forest-hover transition-colors duration-[var(--motion-duration-fast)] ${UNDERLINE[underline]} ${className}`.trim();

  if (to) {
    return (
      <RouterLink to={to} className={base} onClick={onClick}>
        {children}
      </RouterLink>
    );
  }
  if (href) {
    const externalProps = external ? { target: '_blank', rel: 'noopener noreferrer' as const } : {};
    return (
      <a href={href} className={base} onClick={onClick} {...externalProps}>
        {children}
      </a>
    );
  }
  return (
    <button type="button" onClick={onClick} className={base}>
      {children}
    </button>
  );
};

export default Link;
